import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import AddVendor from '../Comman/AddVendor';
import { useDispatch, useSelector } from 'react-redux';
import { GET_VENDOR_LIST } from '../../../../../../../store/actions';
import cogoToast from 'cogo-toast';
import { CustomCard } from '../../../ProgramOnboarding/Components/Comman';
import { ChevronLeft } from 'react-feather';

const SelectVendor = ({ state, setState, setFormCount }) => {
  const dispatch = useDispatch();

  const [isVendorCreate, setIsVendorCreate] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const { getVendorList } = useSelector((state: any) => ({
    getVendorList: state.GetVendorList?.data,
  }));

  useEffect(() => {
    if (!isVendorCreate) {
      dispatch({
        type: GET_VENDOR_LIST,
      });
    }
  }, [isVendorCreate]);

  useEffect(() => {
    if (state?.vendorPricing?.vendors?.[0]) setSelectedVendor(state?.vendorPricing?.vendors?.[0] || null);
  }, [state?.vendorPricing?.vendors]);

  const handleSubmit = () => {
    if (!selectedVendor) {
      cogoToast.error('Please select a vendor to continue');
      return;
    }
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Vendor Onboarding`}
              navigationby={'breadcrumNavigationHandler'}
              navigation={['Management', 'Inventory', 'Onboarding', isVendorCreate ? 'Create Vendor' : 'Select Vendor']}
            />
          </div>
        </div>

        {isVendorCreate ? (
          <AddVendor setIsVendorCreate={setIsVendorCreate} setState={setState} setFormCount={setFormCount} />
        ) : (
          <>
            {' '}
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5 className="m-0 fw-semibold">Select Vendor</h5>

                <Button
                  className="btn btn-success"
                  onClick={() => {
                    setIsVendorCreate(prev => !prev);
                    setSelectedVendor(null);
                  }}
                  color="primary"
                >
                  + Create Vendor
                </Button>
              </CardHeader>
              <CardBody className="pb-5">
                <Row className="d-flex mx-1 mt-2" style={{ height: '340px', overflowY: 'scroll' }}>
                  {getVendorList?.vendors?.map((vendor: any, index: number) => {
                    const isSelected = selectedVendor?.id === vendor.id;
                    return (
                      <CustomCard
                        clientName={`${vendor?.firstName} ${vendor?.lastName}`}
                        country={''}
                        key={index}
                        selected={isSelected}
                        onClick={() => {
                          if (selectedVendor?.id === vendor.id) {
                            cogoToast.info('Vendor already selected');
                            return;
                          }
                          setSelectedVendor(prev => (prev?.id === vendor.id ? null : vendor));
                          setState(prev => ({
                            ...prev,
                            vendorPricing: {
                              ...prev.vendorPricing,
                              vendors: [vendor],
                            },
                          }));
                          setFormCount(prev => prev + 1);
                        }}
                      />
                    );
                  })}
                  {getVendorList?.vendors?.length === 0 && <div className="text-center text-muted mt-3">No clients found</div>}
                </Row>
              </CardBody>
            </Card>
            <div className="d-flex justify-content-between">
              <Button
                onClick={() => setFormCount((prev: number) => prev - 1)}
                color="light"
                className="d-flex align-items-center gap-1 px-3 py-2"
                style={{
                  backgroundColor: '#E9EBEC', // light gray
                  color: '#404B7C', // navy/dark blue
                  fontWeight: 500,
                  boxShadow: 'none',
                  border: 'none',
                }}
              >
                <ChevronLeft size={18} />
                Back
              </Button>{' '}
              <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
                Continue
              </Button>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default SelectVendor;
